import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShareIcon } from '../../assets';
import { useFilterContext } from '../../contexts/FiltersContext';
import Filter, { SharedWithUserFilter } from '../../models/Filter';
import Switch from '../Switch';
import {
  FilterItem,
  FilterItemContainer,
  FilterItemIcon,
  FilterItemInformation,
  FilterItemTitle,
} from './FiltersList.styles';

export const AddSharedWithUserFilter = () => {
  const { t } = useTranslation();
  const { handleApplyFilter, getSelectedFilter, handleRemoveFilter } = useFilterContext();
  const filter = getSelectedFilter(SharedWithUserFilter) as SharedWithUserFilter;

  const [isChecked, setIsChecked] = useState<boolean>(filter?.value);

  const handleSwitchChange = (isChecked: boolean) => {
    setIsChecked(isChecked);
    if (isChecked) {
      let newFilter: Filter;
      if (!filter) {
        newFilter = new SharedWithUserFilter({ value: isChecked });
      } else {
        filter.value = isChecked;
      }
      handleApplyFilter(newFilter);
    } else {
      handleRemoveFilter(filter);
    }
  };

  const handleFilterItemClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handleSwitchChange(!isChecked);
  };

  return (
    <FilterItem $inUse={isChecked} onClick={handleFilterItemClick}>
      <FilterItemContainer>
        <FilterItemIcon $inUse={isChecked}>
          <ShareIcon />
        </FilterItemIcon>
        <FilterItemInformation>
          <FilterItemTitle $inUse={isChecked}>{t('listings.sharedWithMe')}</FilterItemTitle>
        </FilterItemInformation>
      </FilterItemContainer>
      <Switch checked={isChecked} />
    </FilterItem>
  );
};

export default AddSharedWithUserFilter;
